// import { $axios } from "@utils/axios";
import { post, get } from "@/axios";

/**
 * 获取阿里云上传签名
 */
export const getSign = pathName => {
  return post("/customer/oss/sign", new URLSearchParams({ path: pathName }));
};

export const getSignNewApi = ({ bucketName, path, type }) => {
  return post(`/customer/oss/sign/another?bucketName=${bucketName}&path=${path}&type=${type}`);
};

/**
 * 获取阿里云上传文件
 */
export const uploadFileApi = params => {
  return post("/customer/oss/putOSS", params);
};

/**
 * 获取文件
 */
export const getFileUrlApi = params => {
  return get("/oneService/task/selectById", {params});
};
